<div class="wrap">
  <ng-container *ngIf="!isDetailsImageOpen; else detailsTemplate">
    <div class="offer_details_desktop">
      <div class="img_tags" #scrollDesktop>
        <div class="images">
          <div *ngIf="carousel.length === 1" class="mainPicture">
            <img [src]="carousel[0].src" alt="">
          </div>


          <div class="slideshow-container" *ngIf="carousel.length > 1">
            <div class="mySlides fade" *ngFor="let img of carousel; let i = index"
              [ngClass]="img.selected ? '': 'hidden'">
              <div class="numbertext">{{i + 1}} / {{carousel.length}}</div>
              <img [src]="img.src" alt="">
            </div>

            <a class="prev" (click)="plusSlides(-1)">❮</a>
            <a class="next" (click)="plusSlides(1)">❯</a>
          </div>

          <div class="photo_experience" *ngIf="offer?.photoExperience">
            <p>{{offer?.photoExperience}}</p>
          </div>
          <div class="photo_experience_bas">
            <div class="photo_experience_bas_item" *ngIf="offer?.photoExperienceBas">
              <p>{{offer?.photoExperienceBas}}</p>
            </div>
            <div *ngIf="!offer?.photoExperienceBas">
            </div>
            <div class="photo_experience_bas_item" *ngIf="offer?.discipline">
              <p>{{offer?.discipline}}</p>
            </div>
          </div>
        </div>

        <div class="club">
          <div class="logo_club">
            <img [src]="getImg()" alt="">
          </div>

          <div class="tags">
            <div class="tag" *ngFor="let t of tags" [style.background-color]="getValueColorTag(t)"> {{t?.tagName}}</div>
          </div>
        </div>

        <div class="action-add-basket" *ngIf="offer?.offerClubURL || associatedForm">
          <ng-container *ngIf="associatedForm?.formDefinitionKey; else elseTemplate">
            <button mat-raised-button matTooltip="Allez vers la page de souscription du formulaire" matTooltipPosition="right" (click)="openSubscriptionForm()" class="add_basket-button">
              <fa-icon [icon]="getFaIcon('faExternalLinkAlt')"></fa-icon>
              <span>Formulaire d'inscription</span>
            </button>
          </ng-container>
          <ng-template #elseTemplate>
            <a [href]="offer?.offerClubURL" target="_blank" class="add_basket">
              <fa-icon [icon]="getFaIcon('faExternalLinkAlt')"></fa-icon>
              <span>{{ offer?.actionName || offer?.offerClubURL }}</span>
            </a>
          </ng-template>
        </div>

        <div class="files" #desktopPosition appChangeColorTheme attribute="bgc" rgba="0.1">
          <ng-container *ngIf="files?.length > 0">
            <div class="file-title">
              <fa-icon [icon]="getFaIcon('faFile')" appChangeColorTheme attribute="color" [style.margin-right.px]="10"></fa-icon>
              Liste des fichiers
            </div>

            <div class="file-content" *ngFor="let f of files">
              <span>{{f.fileName}}</span>

              <div class="btn_action">
                <fa-icon [icon]="getFaIcon('faDownload')" [matTooltip]="'Télécharger'"
                  (click)="downloadFile(f.offerKey, f.offerFileKey,f.fileName )" (keypress)="downloadFile(f.offerKey, f.offerFileKey,f.fileName )" appChangeColorTheme attribute="color">
                </fa-icon>
              </div>
            </div>
          </ng-container>
        </div>

        <div class="files" #desktopPosition appChangeColorTheme attribute="bgc" rgba="0.1">
          <ng-container *ngIf="externalLinks?.length > 0">
            <div class="link-title">
              <fa-icon [icon]="getFaIcon('faFile')" appChangeColorTheme attribute="color" [style.margin-right.px]="10"></fa-icon>
              Liens utiles
            </div>

            <div class="link-content"  *ngFor="let link of externalLinks">
              <span matTooltip="{{ link.url }}" matTooltipPosition="above">
                <a href="{{ link.url }}" target="_blank">{{link.label}}</a>
              </span>
            </div>
          </ng-container>
        </div>

        <div class="infos_club">
          Rédigé par <strong>{{offer?.writer}} , {{ user?.lastName }} {{ user?.firstName }} </strong> mis à jour le <strong>{{offer?.updatedOn | date: "dd-MM-YYYY"}}</strong>

          <div class="overview_club_content">
            <div class="mail">
              <a href="mailto:{{ user?.email }}" matTooltip="{{ user?.email }}" matTooltipPosition="above">
                <fa-icon [icon]="getFaIcon('faEnvelope')" appChangeColorTheme attribute="color"></fa-icon>
              </a>
              <ng-container *ngIf="userConnected?.role !== 'Visiteurs'">
                <fa-icon [icon]="getFaIcon('faPen')" (click)="getDetails(offer)" (keypress)="getDetails(offer)" appChangeColorTheme attribute="color" matTooltip="Détails de l'article" matTooltipPosition="above">
                </fa-icon>
              </ng-container>
            </div>
          </div>
        </div>

      </div>

      <div class="offer_details">
        <div class="header">
          <h2>{{offer?.offerName}}</h2>
        </div>

        <div class="date-offer" *ngIf="offer?.universes[0]?.universeKey === 5">
          <ng-container *ngIf="offer.endDate; else noEndDateTemplate">
            <ng-container *ngIf="startDate === endDate; else notEqualTemplate">
              <span>Le {{ offer.startDate | date: "dd-MM-YYYY"}}</span>
            </ng-container>
            <ng-template #notEqualTemplate>
              <span>Du {{ offer.startDate | date: "dd-MM-YYYY"}} au {{ offer.endDate | date: "dd-MM-YYYY"}}</span>
            </ng-template>
          </ng-container>
          <ng-template #noEndDateTemplate>
            <span>Le {{ offer.startDate | date: "dd-MM-YYYY" }}</span>
          </ng-template>
        </div>

        <div class="description">
          <p appChangeColorTheme attribute="color" [innerHtml]="offer?.description"></p>
        </div>

        <ul class="precision_offer" style="--numbOfRows:var(--numbOfRows){{getNumberOfRow()}}">

          <li *ngIf="offer?.customerPromise" appChangeColorTheme attribute="bgc" rgba='0.1'>
            <span appChangeColorTheme attribute="color" [innerHtml]="offer?.customerPromise || 'NC'"></span>
          </li>

          <li *ngIf="offer?.informations" appChangeColorTheme attribute="bgc" rgba='0.1'>
            <span appChangeColorTheme attribute="color" id="informations_offer_details" [innerHtml]="offer?.informations">
            </span>
          </li>

          <li *ngIf="offer?.services" appChangeColorTheme attribute="bgc" rgba='0.1'>
            <span appChangeColorTheme attribute="color" [innerHTML]="offer?.services || 'NC'"></span>
          </li>

          <li *ngIf="offer?.price" appChangeColorTheme attribute="bgc" rgba='0.1'>
            <span appChangeColorTheme attribute="color">{{offer?.price || "NC"}}</span>
          </li>

          <li *ngIf="offer?.duration" appChangeColorTheme attribute="bgc" rgba='0.1'>
            <span appChangeColorTheme attribute="color">{{offer?.duration || "NC"}}</span>
          </li>

          <li *ngIf="offer?.prerequisites" appChangeColorTheme attribute="bgc" rgba='0.1'>
            <span appChangeColorTheme attribute="color" [innerHTML]="offer?.prerequisites || 'NC'"></span>
          </li>

          <li *ngIf="offer?.environment" appChangeColorTheme attribute="bgc" rgba='0.1'>
            <span appChangeColorTheme attribute="color" [innerHtml]="offer?.environment || 'NC'"></span>
          </li>

          <li *ngIf="offer?.openingPeriod" appChangeColorTheme attribute="bgc" rgba='0.1'>
            <span appChangeColorTheme attribute="color">{{offer?.openingPeriod || "NC"}}</span>
          </li>

        </ul>

        <div class="action_offer" *ngIf="getNumberOfRow() >= 2">
          <ng-container *ngIf="offer?.offerClubURL">
            <a [href]="offer?.offerClubURL" target="_blank" class="add_basket">

              <fa-icon [icon]="getFaIcon('faExternalLinkAlt')"></fa-icon>

              <ng-container [ngSwitch]="getUnivers()">
                <span *ngSwitchDefault>{{ offer?.actionName || offer?.offerClubURL }}</span>
              </ng-container>
            </a>
          </ng-container>
        </div>
      </div>
    </div>

    <div class="offer_details_tablet" #scrollTablet>
      <div class="images">
        <div *ngIf="carousel.length === 1" class="mainPicture">
          <img [src]="carousel[0].src" alt="">
        </div>

        <div class="slideshow-container" *ngIf="carousel.length > 1">
          <div class="mySlides fade" *ngFor="let img of carousel; let i = index" [ngClass]="img.selected ? '': 'hidden'">
            <div class="numbertext">{{i + 1}} / {{carousel.length}}</div>
            <img [src]="img.src" alt="">
          </div>

          <a class="prev" (click)="plusSlides(-1)">❮</a>
          <a class="next" (click)="plusSlides(1)">❯</a>
        </div>

        <div class="photo_experience" *ngIf="offer?.photoExperience">
          <p>{{offer?.photoExperience}}</p>
        </div>
        <div class="photo_experience_bas">
          <div class="photo_experience_bas_item" *ngIf="offer?.photoExperienceBas">
            <p>{{offer?.photoExperienceBas}}</p>
          </div>
          <div *ngIf="!offer?.photoExperienceBas">
          </div>
          <div class="photo_experience_bas_item" *ngIf="offer?.discipline">
            <p>{{offer?.discipline}}</p>
          </div>
        </div>

      </div>

      <div class="offer_details">

        <div class="header">
          <h2>{{offer?.offerName}}</h2>
        </div>

        <div class="description">
          <p appChangeColorTheme attribute="color" [innerHtml]="offer?.description"></p>
        </div>

        <div class="action_offer">

          <div class="add_wish" (click)="router.url !=='/admin/offers' ?  addOrDeleteToMyWish(offer, $event) : null"
                        (keypress)="router.url !=='/admin/offers' ?  addOrDeleteToMyWish(offer, $event) : null" appChangeColorTheme attribute="bgc">
            <fa-icon [icon]="router.url !=='/admin/offers' ? isInMyWishes(offer?.offerKey) : faHeartEmpty"
              [style.color]="router.url !=='/admin/offers' ? getColorOfHeart(offer?.offerKey):'#2c296d'">
            </fa-icon>
            <span>{{isInMyWishesBoolean(offer?.offerKey) ? 'Ajouté à mes favoris' : 'Ajouter à mes favoris' }}</span>
          </div>


          <div [ngClass]="{add_basket: !isInBasket(), added_basket: isInBasket()}"
            (click)="!isInBasket() ?addOrDeleteToMyShoppingBag(offer): null" *ngIf="!offer?.isExternalOffer"
            (keypress)="!isInBasket() ?addOrDeleteToMyShoppingBag(offer): null"
            appChangeColorTheme attribute="bgc">
            <fa-icon [icon]="isInBasket() ? getFaIcon('faCheck') :  getFaIcon('faShoppingBasket')"></fa-icon>
            <ng-container [ngSwitch]="getUnivers()">
              <div *ngSwitchCase="true">{{ isInBasket()? "Inscrit" : "S'incrire" }}</div>
              <div *ngSwitchDefault>{{ isInBasket()? "Ajouté au panier" : "Ajouter au panier" }}</div>
            </ng-container>
          </div>

          <a [href]="offer?.offerClubURL" target="_blank" class="add_basket" *ngIf="offer?.isExternalOffer">
            <fa-icon [icon]="getFaIcon('faExternalLinkAlt')"></fa-icon>
            Acheter sur le site du club
          </a>
        </div>

        <div class="club">

          <div class="logo_club">
            <img [src]="getImg()" alt="">
          </div>

          <div class="tags">
            <div class="tag" *ngFor="let t of offer?.tags" [style.background-color]="getValueColorTag(t)"> {{t?.tagName}}</div>
          </div>

        </div>

        <div class="infos_club">
          Rédigé par <strong>{{offer?.clubName}} , {{ userConnected?.name }} </strong> mis à jour le <strong>{{offer?.startDate | date: "dd-MM-YYYY"}}</strong>

          <div class="overview_club_content">
            <div class="mail">
              <a href="mailto:{{club?.mail}}">
                <fa-icon [icon]="getFaIcon('faEnvelope')" appChangeColorTheme attribute="color"></fa-icon>
                {{club?.mail}}
              </a>
            </div>
          </div>

          <p class="redirect_file" *ngIf="this.files?.length" (click)="scrollTo(scrollTablet, tabletPosition)" (keypress)="scrollTo(scrollTablet, tabletPosition)">
            <fa-icon [icon]="getFaIcon('faFile')" appChangeColorTheme attribute="color"></fa-icon> Liste des fichiers
            ({{files?.length}})
          </p>

        </div>

        <ul class="precision_offer">
          <li *ngIf="offer?.customerPromise" appChangeColorTheme attribute="bgc" rgba="0.1">
            <span appChangeColorTheme attribute="color" [innerHtml]="offer?.customerPromise || 'NC'"></span>
          </li>

          <li *ngIf="offer?.informations" appChangeColorTheme attribute="bgc" rgba="0.1">
            <span appChangeColorTheme attribute="color" [innerHtml]="offer?.informations || 'NC'"></span>
          </li>

          <li *ngIf="offer?.practicePlace" appChangeColorTheme attribute="bgc" rgba="0.1">
            <span appChangeColorTheme attribute="color" *ngIf="offer.fullPracticePlace">
              {{offer.fullPracticePlace?.label + ' - '}}
              <ng-container *ngIf="offer.fullPracticePlace?.country">
                {{offer.fullPracticePlace?.country}}
              </ng-container>
              <ng-container *ngIf="offer.fullPracticePlace?.region">
                {{offer.fullPracticePlace?.region}}
              </ng-container>
              <ng-container *ngIf="offer.fullPracticePlace?.department">
                {{offer.fullPracticePlace?.department}}
              </ng-container>
              <ng-container *ngIf="offer.fullPracticePlace?.city">
                {{offer.fullPracticePlace?.city}}
              </ng-container>
              <ng-container *ngIf="offer.fullPracticePlace?.postalCode">
                {{offer.fullPracticePlace?.postalCode}}
              </ng-container>
              <ng-container *ngIf="offer.fullPracticePlace?.address">
                {{offer.fullPracticePlace?.address}}
              </ng-container>
              <ng-container *ngIf="offer.fullPracticePlace?.box">
                {{offer.fullPracticePlace?.box}}
              </ng-container>
            </span>
          </li>

          <li *ngIf="offer?.services" appChangeColorTheme attribute="bgc" rgba="0.1">
            <span appChangeColorTheme attribute="color" [innerHtml]="offer?.services || 'NC'"></span>
          </li>

          <li *ngIf="offer?.price" appChangeColorTheme attribute="bgc" rgba="0.1">
            <span appChangeColorTheme attribute="color">{{offer?.price || "NC"}}</span>
          </li>



          <li *ngIf="offer?.duration" appChangeColorTheme attribute="bgc" rgba="0.1">
            <span appChangeColorTheme attribute="color">{{offer?.duration || "NC"}}</span>
          </li>

          <li *ngIf="offer?.environment" appChangeColorTheme attribute="bgc" rgba="0.1">
            <span appChangeColorTheme attribute="color" [innerHtml]="offer?.environment || 'NC'"></span>
          </li>

          <li *ngIf="offer?.prerequisites" appChangeColorTheme attribute="bgc" rgba="0.1">
            <span appChangeColorTheme attribute="color" [innerHtml]="offer?.prerequisites || 'NC'"></span>
          </li>

          <li *ngIf="offer?.openingPeriod" appChangeColorTheme attribute="bgc" rgba="0.1">
            <span appChangeColorTheme attribute="color">{{offer?.openingPeriod || "NC"}}</span>
          </li>
        </ul>
      </div>

      <ul class="files" [style.opacity]="this.files?.length ? 1 : 0" #tabletPosition appChangeColorTheme attribute="bgc"
        rgba="0.1">
        <h4>
          <fa-icon [icon]="getFaIcon('faFile')" appChangeColorTheme attribute="color" [style.margin-right.px]="10">
          </fa-icon> Liste des
          fichiers
        </h4>

        <li *ngFor="let f of files">
          <span>{{f.fileName}}</span>

          <div class="btn_action">
            <fa-icon [icon]="getFaIcon('faDownload')" [matTooltip]="'Télécharger'"
              (click)="downloadFile(f.offerKey, f.offerFileKey,f.fileName )" (keypress)="downloadFile(f.offerKey, f.offerFileKey,f.fileName )" appChangeColorTheme attribute="color">
            </fa-icon>
          </div>
        </li>

      </ul>

    </div>

    <div class="offer_details_mobile" #scrollMobile>
      <div class="images">
        <div *ngIf="carousel.length === 1" class="mainPicture">
          <img [src]="carousel[0].src" alt="">
        </div>

        <div class="slideshow-container" *ngIf="carousel.length > 1">
          <div class="mySlides fade" *ngFor="let img of carousel; let i = index" [ngClass]="img.selected ? '': 'hidden'">
            <div class="numbertext">{{i + 1}} / {{carousel.length}}</div>
            <img [src]="img.src" alt="">
          </div>

          <a class="prev" (click)="plusSlides(-1)">❮</a>
          <a class="next" (click)="plusSlides(1)">❯</a>
        </div>

        <div class="photo_experience" *ngIf="offer?.photoExperience">
          <p>{{offer?.photoExperience}}</p>
        </div>

        <div class="photo_experience_bas">
          <div class="photo_experience_bas_item" *ngIf="offer?.photoExperienceBas">
            <p>{{offer?.photoExperienceBas}}</p>
          </div>
          <div *ngIf="!offer?.photoExperienceBas">
          </div>
          <div class="photo_experience_bas_item" *ngIf="offer?.discipline">
            <p>{{offer?.discipline}}</p>
          </div>
        </div>
      </div>

      <div class="offer_details">
        <div class="tags">
          <div class="tag" *ngFor="let t of tags" [style.background-color]="getValueColorTag(t)"> {{t?.tagName}}</div>
        </div>

        <div class="header">
          <h2>{{offer?.offerName}}</h2>
        </div>

        <div class="description">
          <p appChangeColorTheme attribute="color" [innerHtml]="offer?.description"></p>
        </div>

        <div class="action-add-basket" *ngIf="offer?.offerClubURL || associatedForm">
          <ng-container *ngIf="associatedForm?.formDefinitionKey; else elseTemplate">
            <button mat-raised-button matTooltip="Allez vers la page de souscription du formulaire" matTooltipPosition="right" (click)="openSubscriptionForm()" class="add_basket-button">
              <fa-icon [icon]="getFaIcon('faExternalLinkAlt')"></fa-icon>
              <span>Formulaire d'inscription</span>
            </button>
          </ng-container>
          <ng-template #elseTemplate>
            <a [href]="offer?.offerClubURL" target="_blank" class="add_basket">
              <fa-icon [icon]="getFaIcon('faExternalLinkAlt')"></fa-icon>
              <span>{{ offer?.actionName || offer?.offerClubURL }}</span>
            </a>
          </ng-template>
        </div>

        <div class="files" #desktopPosition appChangeColorTheme attribute="bgc" rgba="0.1">
          <ng-container *ngIf="files?.length > 0">
            <div class="file-title">
              <fa-icon [icon]="getFaIcon('faFile')" appChangeColorTheme attribute="color" [style.margin-right.px]="10"></fa-icon>
              Liste des fichiers
            </div>

            <div class="file-content" *ngFor="let f of files">
              <span>{{f.fileName}}</span>

              <div class="btn_action">
                <fa-icon [icon]="getFaIcon('faDownload')" [matTooltip]="'Télécharger'"
                  (click)="downloadFile(f.offerKey, f.offerFileKey,f.fileName )" (keypress)="downloadFile(f.offerKey, f.offerFileKey,f.fileName )" appChangeColorTheme attribute="color">
                </fa-icon>
              </div>
            </div>
          </ng-container>
        </div>

        <div class="files" #desktopPosition appChangeColorTheme attribute="bgc" rgba="0.1">
          <ng-container *ngIf="externalLinks?.length > 0">
            <div class="link-title">
              <fa-icon [icon]="getFaIcon('faFile')" appChangeColorTheme attribute="color" [style.margin-right.px]="10"></fa-icon>
              Liens utiles
            </div>

            <div class="link-content"  *ngFor="let link of externalLinks">
              <span matTooltip="{{ link.url }}" matTooltipPosition="above">
                <a href="{{ link.url }}" target="_blank">{{link.label}}</a>
              </span>
            </div>
          </ng-container>
        </div>

        <ul class="precision_offer">
          <li *ngIf="offer?.customerPromise" appChangeColorTheme attribute="bgc" rgba="0.1">
            <span appChangeColorTheme attribute="color" [innerHtml]="offer?.customerPromise || 'NC'"></span>
          </li>

          <li *ngIf="offer?.informations" appChangeColorTheme attribute="bgc" rgba="0.1">
            <span appChangeColorTheme attribute="color" [innerHtml]="offer?.informations || 'NC'"></span>
          </li>

          <li *ngIf="offer?.practicePlace" appChangeColorTheme attribute="bgc" rgba="0.1">
            <span appChangeColorTheme attribute="color" *ngIf="offer.fullPracticePlace">
              <ng-container *ngIf="offer.fullPracticePlace?.label">
                {{offer.fullPracticePlace?.label}} -
              </ng-container>
              <ng-container *ngIf="offer.fullPracticePlace?.country">
                {{offer.fullPracticePlace?.country}}
              </ng-container>
              <ng-container *ngIf="offer.fullPracticePlace?.region">
                {{offer.fullPracticePlace?.region}}
              </ng-container>
              <ng-container *ngIf="offer.fullPracticePlace?.department">
                {{offer.fullPracticePlace?.department}}
              </ng-container>
              <ng-container *ngIf="offer.fullPracticePlace?.city">
                {{offer.fullPracticePlace?.city}}
              </ng-container>
              <ng-container *ngIf="offer.fullPracticePlace?.postalCode">
                {{offer.fullPracticePlace?.postalCode}}
              </ng-container>
              <ng-container *ngIf="offer.fullPracticePlace?.address">
                {{offer.fullPracticePlace?.address}}
              </ng-container>
              <ng-container *ngIf="offer.fullPracticePlace?.box">
                {{offer.fullPracticePlace?.box}}
              </ng-container>
            </span>
          </li>

          <li *ngIf="offer?.services" appChangeColorTheme attribute="bgc" rgba="0.1">
            <span appChangeColorTheme attribute="color" [innerHTML]="offer?.services || 'NC'"></span>
          </li>

          <li *ngIf="offer?.price" appChangeColorTheme attribute="bgc" rgba="0.1">
            <span appChangeColorTheme attribute="color">{{offer?.price || "NC"}}</span>
          </li>

          <li *ngIf="offer?.duration" appChangeColorTheme attribute="bgc" rgba="0.1">
            <span appChangeColorTheme attribute="color">{{offer?.duration || "NC"}}</span>
          </li>

          <li *ngIf="offer?.environment" appChangeColorTheme attribute="bgc" rgba="0.1">
            <span appChangeColorTheme attribute="color" [innerHtml]="offer?.environment || 'NC'"></span>
          </li>

          <li *ngIf="offer?.prerequisites" appChangeColorTheme attribute="bgc" rgba="0.1">
            <span appChangeColorTheme attribute="color" [innerHTML]="offer?.prerequisites || 'NC'"></span>
          </li>

          <li *ngIf="offer?.openingPeriod" appChangeColorTheme attribute="bgc" rgba="0.1">
            <span appChangeColorTheme attribute="color">{{offer?.openingPeriod || "NC"}}</span>
          </li>
        </ul>

        <div class="club">
          <div class="logo_club">
            <img [src]="getImg()" alt="logo_club">
          </div>

          <div class="infos_club">
            Rédigé par <strong>{{offer?.writer}} , {{ user?.lastName }} {{ user?.firstName }} </strong> mis à jour le <strong>{{offer?.updatedOn | date: "dd-MM-YYYY"}}</strong>

            <div class="overview_club_content">
              <div class="mail">
                <a href="mailto:{{ user?.email }}" matTooltip="{{ user?.email }}" matTooltipPosition="above">
                  <fa-icon [icon]="getFaIcon('faEnvelope')" appChangeColorTheme attribute="color"></fa-icon>
                </a>
                <ng-container *ngIf="userConnected?.role !== 'Visiteurs'">
                  <fa-icon [icon]="getFaIcon('faPen')" (click)="getDetails(offer)" (keypress)="getDetails(offer)" appChangeColorTheme attribute="color" matTooltip="Détails de l'article" matTooltipPosition="above">
                  </fa-icon>
                </ng-container>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </ng-container>

  <ng-template #detailsTemplate>
    <app-header-image-details [notice]="notice"></app-header-image-details>
  </ng-template>

</div>
